/**
 * Reads the API response and create objects based on the model provided.
 * This data layer abstraction allow us to easily map API changes with UI fields
 * in each of the defined models.
 */

import Types from './types';
import { read } from './object';

export function processFields(fields, rawData) {
  const data = {};

  fields.forEach((field) => {
    if (Types.isString(field)) {
      data[field] = rawData[field] || '';
    } else if (Types.isObject(field)) {
      // Name prop is required
      if (!field.name) {
        console.error([ // eslint-disable-line no-console
          '\'name\' property is required when using an object as field,',
          ' otherwhise an \'undefined\' field will be created!'].join(''), field);
      }

      if (Types.isFunction(field.mapping)) {
        data[field.name] = field.mapping(rawData) || field.defaultValue;
      } else {
        data[field.name] = rawData[field.name] || field.defaultValue;
      }
    }
  });

  return data;
}

/**
 * @param {Object} model - The model to use
 * @param {Object} rawData - The data to map
 * @return {Object} The model data
 */

export function processRecord(Model, rawData) {
  if (rawData !== undefined) {
    const data = new Model();

    if (!Model.fields) {
      throw new Error('Make sure to declare an array of `fields` into your model.');
    }

    Object.assign(data, processFields(Model.fields, rawData));

    return data;
  }

  return rawData;
}

export default function reader(config, response) {
  if (!config.model) {
    throw new Error('The model is required! Make sure to add the model to the reader.');
  }

  const raw = config.root ? read(config.root, response) : response;
  
  if (Types.isArray(raw)) {
    return raw.map(record => processRecord(config.model, record));
  }

  return processRecord(config.model, raw);
}
